export const Statistic = () => {
  const stats = [
    {
      id: 4,
      name: 'شرکت کنندگان دوره Shape Up بطور متوسط<b style="color:#FFD700"> بیش از ۸ کیلوگرم </b> کاهش وزن ماندگار داشتند.',
      value: '۸ کیلوگرم',
    },
    {
      id: 5,
      name: ' کاهش سایز و دور کمر شرکت کنندگان بطور متوسط <b style="color:#FFD700">۱۰ سانتی متر</b> بود.',
      value: '۱۰ سانتی متر',
    },
    {
      id: 1,
      name: ' از این دوره <b style="color:#FFD700">رضایت کامل</b> داشتند و ورزش و تغذیه ی درست را تبدیل به  <b style="color:#FFD700">روتین</b> کردند.',
      value: '۹۷٪',
    },

    {
      id: 3,
      name: 'شرکت کنندگان به بدن خود<b style="color:#FFD700"> حس بهتری</b> داشتند.',
      value: '۹۵٪',
    },
  ];

  return (
    <section className="text-gray-600 body-font">
      <div className="text-main lg:px-8 lg:py-20 bg-main text-white">
        <div className="grid gap-10 row-gap-8 lg:grid-cols-4 px-3 py-4">
          {stats.map((stat) => (
            <div
              key={stat.id}
              className={`flex flex-col items-center p-4 bg-blue-600 rounded-lg shadow-lg`}>
              <div className="flex">
                <h6 className="mr-2 text-3xl font-bold md:text-3xl text-deep-purple-accent-400 text-center">
                  {stat.value}
                </h6>
                <div className="flex items-center justify-center rounded-full bg-teal-accent-400 w-7 h-7">
                  <svg
                    className="text-teal-900 w-7 h-7"
                    stroke="currentColor"
                    viewBox="0 0 52 52">
                    <polygon
                      strokeWidth="3"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      fill="none"
                      points="29 13 14 29 25 29 23 39 38 23 27 23"
                    />
                  </svg>
                </div>
              </div>

              <p
                className="text-white font-custom1 text-center mt-4"
                dangerouslySetInnerHTML={{ __html: stat.name }}></p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};
